import Vue from 'vue'
import VueRouter from 'vue-router'
import { time } from 'echarts'
const index = () => import('../views/index.vue')
const home = () => import('../views/home/home.vue')
const login = () => import('../views/login/login.vue')
const instrument = () => import('../views/instrument/instrument.vue')
const accountset = () => import('../views/login/accountset.vue')
const information = () => import('../views/login/information.vue')
const fourquadrants = () => import('../views/fourquadrants/fourquadrants.vue')
const listview = () => import('../views/listview/listView.vue')
const fourlists = () => import('../views/fourlists/fourlists.vue')
const month = () => import('../views/month/month.vue')
const cards = () => import('../views/cards/cards.vue')
const weeks = () => import('../views/month/weeks.vue')
const timeview = () => import('../views/timeview/timeview.vue')
const skinpeeler = () => import('../views/login/skinpeeler.vue')
const sumup = () => import('../views/sumup/sumup.vue')
const statisticsView = () => import('../views/statistics/statisticsView.vue')

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: "login",
    component: login,
  },
  {
    path: '/index',
    name: "index",
    component: index,
    redirect: { name: 'instrument' },
    children: [
      {
        path: '/index/instrument',
        name: 'instrument',
        component: instrument
      },

      {
        path: '/index/home',
        name: "home",
        component: home
      },
      {
        path: '/index/accountset',
        name: "accountset",
        component: accountset
      },
      {
        path: '/index/skinpeeler',
        name: "skinpeeler",
        component: skinpeeler
      },
      {
        path: '/index/information',
        name: "information",
        component: information
      },
      {
        path: '/index/fourquadrants',
        name: "fourquadrants",
        component: fourquadrants
      },
      {
        path: '/index/listview',
        name: "listview",
        component: listview
      },
      {
        path: '/index/fourlists',
        name: "fourlists",
        component: fourlists
      },
      {
        path: '/index/month',
        name: "month",
        component: month
      },
      {
        path: '/index/cards',
        name: "cards",
        component: cards
      },
      {
        path: '/index/weeks',
        name: "weeks",
        component: weeks
      },
      {
        path: '/index/sumup',
        name: "sumup",
        component: sumup
      },
      {
        path: '/index/timeview',
        name: "timeview",
        component: timeview
      },
      {
        path: '/index/statisticsView',
        name: 'statisticsView'
      }
    ]
  },
]

// const router = new VueRouter({   
//   mode: 'history',
//   base: process.env.BASE_URL,
//   routes
// })

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, saveTop) {
    if (saveTop) {
      return saveTop;
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach((to, from, next) => {
  console.log(to, "要去的页面")
  console.log(from, "来自的页面")
  const isLogin = localStorage.token ? true : false
  let nowtime = Date.parse(new Date())
  let signtime = localStorage.getItem("signtime")
  if (to.path === '/') {
    if (isLogin) {
      console.log("存在token")
      if (!signtime || nowtime - signtime > 2592000000) {
        console.log("超过登陆时间")
        localStorage.clear()
        next('/')
      } else {
        console.log("下一个路由1")
        next('/index/instrument')
        return;
      }
    } else {
      next()
    }
  } else {
    console.log(to.path, "不去跟路由")
    isLogin ? next() : next('/')
  }
})


export default router
